<ng-container *ngIf="!isWalmartAccount">
  <div class="sku-panel_devider"></div>
  <div class="input-container">
    <div class="input-container_label">FBA Type:</div>
    <select
      class="input-container_input input-container_input--thin"
      (change)="updateFbaType()"
      [formControl]="shipmentType"
    >
      <option *ngFor="let type of fbaTypes" [value]="type.id">
        {{ type.name }}
      </option>
    </select>
  </div>
</ng-container>
<div class="sku-panel_devider"></div>

<div *ngIf="isPlanyard" style="display: contents;">
  <app-sku-mapping
    [mappings]="mappings"
    (viewEvent)="editMapping()"
  ></app-sku-mapping>

</div>

<div *ngIf="isPlanyard && (selectedSku.fulfillmentType === 'FBM' || selectedSku.fulfillmentType == 'WFS Eligible')"  style="display: contents;">
  <div class="sku-panel_devider"></div>
  
  <app-sync-history
    [sku]="selectedSku"
  ></app-sync-history>
</div>
